export default function basket() {
    return {
        restrict: "E",
        scope: {
            housetype: "=",
            ariaLabelSuffix: "@",
        },
        replace: false,
        template: require("./template.html"),

        controller: function (
            $scope,
            $rootScope,
            $timeout,
            $location,
            Basket,
            BasketToCheckout,
            houseService,
            siteService,
            loginModalFactory,
            Scroll,
            $q,
            BasketStorage,
            BookingPeriods,
            Users
        ) {
            $scope.siteService = siteService;
            $scope.priceHasChanged = false;
            $scope.houseType = houseService.searchFilter.houseType;
            $scope.houseCategory = houseService.searchFilter.houseCategory;
            $scope.currentBookings = Basket.currentBookings;
            $scope.currentActivity = Basket.getBookingActivity();
            $scope.currentLocation = BasketStorage.getBookingLocation();

            // Recalculate prices if user is authenticated
            Users.isAuthenticated()
                .then((userId) => {
                    // Recalculate price
                    const promises = $scope.currentBookings.map((booking) => {
                        return BookingPeriods.calculatePrice(
                            booking.BookingStart,
                            booking.BookingEnd,
                            booking.LaneID,
                            $scope.currentActivity.CategoryID,
                            userId
                        ).then(
                            (res) => {
                                // Update price (if changed)
                                if (booking.Price != res.data.price) {
                                    booking.Price = res.data.price;
                                    $scope.priceHasChanged = true;
                                }
                                return $q.resolve();
                            },
                            (err) => {
                                console.warn(err);
                                return $q.reject({
                                    reason: "API error calculatePrice",
                                    obj: err,
                                });
                            }
                        );
                    });

                    $q.all(promises).then(() => {
                        // Save booking in localstorage
                        BasketStorage.setBookingsStorage(
                            $scope.currentBookings
                        );
                    });
                })
                .catch(function () {});

            $scope.checkout = function ($event) {
                $timeout(() => {
                    BasketToCheckout.goToCheckout(
                        $scope.currentActivity,
                        $scope.currentBookings
                    ).then(
                        () => {
                            $rootScope.$broadcast("close-modal-from-inside", {
                                event: $event,
                            });

                            $location.path("/checkout/bookingoptions");
                        },
                        (err) => {
                            console.warn(err);
                            handleCases(err);
                        }
                    );
                }, 500); // basket aside must have time to close before opening login-modal
            };

            const handleCases = (err) => {
                if (err.reason == "no-basket-bookings") {
                    console.warn(
                        " no basket-bookings - This should never happen!"
                    );
                    return false;
                }

                if (err.reason == "user-not-authorized") {
                    loginModalFactory.modal().then((res) => {
                        if (res == "login-user") {
                            $location.path("/basket");
                        }
                        return false;
                    });
                }

                if (err.reason == "await-user-to-remove-periods") {
                    const unavailableBookings = err.obj.unavailablePeriods;

                    const unavailableUniqueKeys = unavailableBookings.map(
                        (booking) => {
                            return booking.Periods[0].UniqueKey;
                        }
                    );

                    $scope.currentBookings.forEach((booking) => {
                        booking.Message =
                            unavailableUniqueKeys.indexOf(
                                booking.Periods[0].UniqueKey
                            ) !== -1
                                ? "Denne booking er nu reserveret af en anden bruger"
                                : null;

                        booking;
                    });

                    if ($location.path() == "/basket") {
                        scrollToDeclinedBooking(unavailableBookings);
                    } else {
                        // Used to re-open Aside on mobile!
                        $rootScope.$broadcast(
                            "declined-bookings",
                            unavailableBookings
                        );

                        if (siteService.deviceMode === "desktop") {
                            scrollToDeclinedBooking(unavailableBookings);
                        }
                    }
                }

                if (err.reason == "could-not-create-booking-periods") {
                    // Clear bookingID
                    Basket.setBookingId(null);

                    // Try to book again
                    $scope.checkout();
                }
            };

            $scope.getTotal = function () {
                var total = 0;

                for (var i = 0; i < Basket.currentBookings.length; i++) {
                    var booking = Basket.currentBookings[i];
                    total += booking.Price;
                }

                return total;
            };

            const scrollToDeclinedBooking = (declinedBookings) => {
                var offset = siteService.headerHeight + 55;
                // Scrolll to first declined booking
                scrollToResults("basket-id-" + declinedBookings[0].ID, offset);
            };

            const scrollToResults = (elemID, offset) => {
                Scroll.to(elemID, offset);
            };
        },
    };
}
